import React from "react"

import Drawer from "devextreme-react/drawer"
import ChangePassword from "./changePassword"
import TreeList, { Column, FilterRow } from "devextreme-react/tree-list"
import TabPanel from "devextreme-react/tab-panel"
import Cookies from "js-cookie"
import { Template } from "devextreme-react/core/template"
import { SpeedDialAction } from "devextreme-react/speed-dial-action"
import config from "devextreme/core/config"

class MyToolbar extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = { ...props }
        this.state.theme = localStorage.getItem(this.state.app.themeStorageName)
        if (this.state.theme === null) this.state.theme = "carmine"
        this.isSm = window.innerWidth <= 670
        this.isMd = window.innerWidth <= 767
        this.opened = !this.isMd

        this.state.menu = Cookies.get("menu")
        this.state.access = Cookies.get("access")

        this.state.token = Cookies.get("token")
        config({
            floatingActionButtonConfig: {
                icon: "rowfield",
                shading: true,
                position: {
                    my: "left bottom",
                    at: "left bottom",
                    offset: "5 -5"
                }
            }
        })
    }
    componentDidMount() {
        window.addEventListener("resize", this.updateWindowDimensions)
        if (this.state.menu === undefined || this.state.menu === null) this.menu(this.state.token)
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions)
    }
    openedStateMode = () => {
        return this.isSm ? "overlap" : "shrink"
    }
    speedIcon = () => {
        return this.drawer === undefined ? (this.opened ? "close" : "menu") : this.drawer.option("opened") ? "close" : "menu"
    }
    updateWindowDimensions = (e) => {
        e = {
            isSm: window.innerWidth <= 670,
            isMd: window.innerWidth <= 767
        }
        if (e.isSm !== this.isSm) this.onSmChange((this.isSm = e.isSm))
        if (e.isMd !== this.isMd) this.onMdChange((this.isMd = e.isMd))
    }
    onSmChange = (is) => {
        if (this.drawer.option("openedStateMode") !== this.openedStateMode()) this.drawer.option("openedStateMode", this.openedStateMode())
    }
    onMdChange = (is) => {}
    menu = () => {
        this.state.fn.post({
            url: "menu",
            token: this.state.token,
            success: (e) => {
                if (e.menu[0].id !== "") e.menu.unshift({ id: "", parent: null, name: "Home" })
                Cookies.set("access", JSON.stringify(e.access))
                Cookies.set("menu", JSON.stringify(e.menu))
                this.setState({ menu: e.menu })
            },
            error: (e) => this.state.fn.logOut(),
            warning: (e) => this.state.fn.logOut()
        })
    }
    onGetUrl = (e, help) => {
        help = { link: window.location.href.split("#") }
        help.hash = help.link.length > 1 ? help.link[1] : ""
        help.link = help.link[0]

        if (help.hash.substr(0, 1) === "/") help.hash = help.hash.substr(1)
        if (help.hash.substr(help.hash.length - 1) === "/") help.hash = help.hash.substr(0, help.hash.length - 1)

        if (help.link.substr(help.link.length - 1) === "/") help.link = help.link.substr(0, help.link.length - 1)
        if (e !== undefined) help.link += "/#/" + e.data.id.split(".").join("/")
        else return help

        return help
    }
    onMenuClick = (e, help) => {
        help = this.onGetUrl(e)
        if (help.hash.split("/").join(".") === e.data.id) return
        // console.log(help.link)
        window.location.href = help.link
        // window.location.reload()
        // console.log(window.location.href)
        this.onSelected({ x: e.data })
    }
    onSelected = (e, x) => {
        x = false
        if (e.x.parent !== null) x = true
        if (e.x.parent === null && (e.x.id === "" || e.x.id === "dashboard")) x = true
        if (x) {
            e.tempMain = [...this.state.menu]
            e.filter = e.tempMain.filter((expr) => {
                return expr.id === e.x.id
            })
            if (this.mainTab === undefined) {
                this.state.renderItemMain(e.x)
            } else {
                this.mainTab.option("dataSource", [e.x])
                this.mainTab.option("selectedItem", e.x)
            }
        }
    }
    menuToolBar = (e) => {
        e.toolbarOptions.items.push({
            location: "after",
            widget: "dxSelectBox",
            options: {
                width: 170,
                items: this.themeList(),
                value: this.state.theme,
                displayExpr: "name",
                valueExpr: "id",
                onValueChanged: (e) => {
                    this.setState({ theme: e.value })
                    localStorage.setItem(this.state.app.themeStorageName, e.value)
                    this.state.updateTheme(e.value)
                }
            }
        })
        e.toolbarOptions.items.push({
            location: "after",
            widget: "dxButton",
            options: {
                icon: "key",
                type: "default",
                onClick: () =>
                    this.state.fn.modal({
                        title: "Change Password",
                        height: "auto",
                        width: 290,
                        text: <ChangePassword app={this.state.app} fn={this.state.fn} />,
                        backgroundStyle: "dx-theme-background-color dx-theme-text-color"
                    })
            }
        })
        e.toolbarOptions.items.push({
            location: "after",
            widget: "dxButton",
            options: {
                icon: "runner",
                type: "danger",
                onClick: this.state.fn.logOut
            }
        })
        this.language().map((expr) =>
            e.toolbarOptions.items.push({
                locateInMenu: "always",
                widget: "dxButton",
                options: {
                    text: expr.name,
                    onClick: (x) => {
                        this.state.fn.post({
                            url: "language",
                            data: { language: expr.id },
                            success: (x) => {
                                Cookies.remove("menu")
                                Cookies.remove("access")
                                window.location.reload()
                            }
                        })
                    },
                    icon: expr.icon
                }
            })
        )
    }
    renderNavigation = (e) => {
        return (
            <TreeList
                onToolbarPreparing={this.menuToolBar}
                dataSource={this.state.menu}
                parentIdExpr="parent"
                className="menu-tree"
                keyExpr="id"
                displayExpr="name"
                selectionMode="single"
                dataStructure="plain"
                selectByClick={true}
                searchEnabled={true}
                searchMode="contains"
                onInitialized={(e) => {
                    this.setState({ tree: e.component })
                    e.component.option("width", 300)
                }}
                elementAttr={{
                    class: "dx-theme-background-color dx-theme-text-color p-1 border-right dx-theme-border-color height-100 pb-5 pt-2"
                }}
                onRowClick={this.onMenuClick}
                filterMode="fullBranch"
                autoExpandAll={true}
                showColumnHeaders={false}
            >
                {/*<Selection mode="single" />*/}
                <FilterRow visible={true} />
                <Column
                    dataField="name"
                    allowSorting={false}
                    cellRender={(e) => {
                        return (
                            <>
                                <span className={e.data.icon}></span>
                                <span className="ml-1">{e.data.name}</span>
                            </>
                        )
                    }}
                />
            </TreeList>
        )
    }
    themeList = () => [
        //{ id: "material.blue.dark", name: "Blue Dark" },
        //{ id: "material.blue.light", name: "Blue Light" },
        { id: "carmine", name: "Carmine" },
        { id: "contrast", name: "Contrast" },
        { id: "dark", name: "Dark" },
        { id: "darkmoon", name: "Dark Moon" },
        { id: "darkviolet", name: "Dark Violet" },
        { id: "greenmist", name: "Green Mist" },
        { id: "light", name: "Light" },
        //{ id: "material.lime.dark", name: "Lime Dark" },
        //{ id: "material.lime.light", name: "Lime Light" },
        //{ id: "material.orange.dark", name: "Orange Dark" },
        //{ id: "material.orange.light", name: "Orange Light" },
        //{ id: "material.purple.dark", name: "Purple Dark" },
        { id: "material.purple.light.compact", name: "Purple Light" },
        { id: "softblue", name: "Soft Blue" }
        //{ id: "material.teal.dark", name: "Teal Dark" },
        //{ id: "material.teal.light", name: "Teal Light" }
    ]
    language = () => [
        { id: "id", name: "Bahasa", icon: "fa fa-flag-o" },
        { id: "en", name: "English", icon: "fa fa-flag-checkered" }
    ]
    render(x) {
        x = {}
        if (this.state.menu !== undefined && this.state.menu !== null) {
            x.dashboard = this.state.menu.filter((e) => e.id === "")
            if (x.dashboard.length > 0) x.dashboard[0].id = "dashboard"
        }
        return this.state.menu === undefined || this.state.menu === null ? (
            <>Please wait ...</>
        ) : (
            <>
                <Drawer
                    defaultOpened={this.opened}
                    onInitialized={(e) => {
                        this.drawer = e.component
                        e.component.option("openedStateMode", (this.openState = "shrink"))
                    }}
                    position={"left"}
                    revealMode={"expand"}
                    component={this.renderNavigation}
                    className="position-fixed top-0"
                >
                    <this.renderMain />
                </Drawer>
                <SpeedDialAction
                    onInitialized={(e) => {
                        this.menuButton = e.component
                        this.menuButton.option("icon", this.speedIcon())
                    }}
                    index={1}
                    onClick={() => {
                        if (this.drawer.option("openedStateMode") !== this.openedStateMode())
                            this.drawer.option("openedStateMode", (this.openState = this.openedStateMode()))
                        this.drawer.toggle()
                        this.menuButton.option("icon", this.speedIcon())
                    }}
                />
            </>
        )
    }
    renderMain = (x, select, help) => {
        x = this.state.menu.filter(function (expr) {
            return (expr.parent !== null && expr.parent !== undefined) || (expr.parent === null && (expr.id === "" || expr.id === "dashboard"))
        })
        help = this.onGetUrl()
        select = x.filter((expr) => expr.id === help.hash.split("/").join("."))
        if (select.length > 0) select = select[0]
        else if (x.length > 0) select = x[0]
        else select = {}

        // return this.state.renderItemMain(select)
        return (
            <TabPanel
                deferRendering={true}
                // dataSource={x}
                itemRender={this.state.renderItemMain}
                itemTitleRender={this.renderTitleMain}
                className="hidden-grid"
                keyExpr="id"
                onInitialized={(e) => {
                    this.mainTab = e.component
                    setTimeout(() => {
                        e.component.option("dataSource", [select])
                        e.component.option("selectedItem", select)
                        e.component.repaint()
                    }, 100)
                }}
                // defaultSelectedItem={help.select}
            />
        )
    }
    renderTitleMain = (e) => {
        return (
            <>
                <span className="pr-4">{e.name}</span>
            </>
        )
    }
}

export default MyToolbar
